import { render, staticRenderFns } from "./CreateCustomActivity.vue?vue&type=template&id=61bb72ca"
import script from "./CreateCustomActivity.vue?vue&type=script&lang=js"
export * from "./CreateCustomActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports